import { createRouter, createWebHistory, onBeforeRouteUpdate } from 'vue-router';

import Layout from '@/layout';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            name: 'homePage',
            meta: { name: '起重汇' },
            component: () => import('@/views/homepage/index.vue')
        },
        {
            path: '/test',
            name: 'testPage',
            meta: { name: '起重汇' },
            component: () => import('@/views/test/index.vue')
        },
        {
            path: '/admin',
            name: 'admin',
            component: Layout,
            redirect: '/admin/sale-nets/list',
            meta: {
                name: '权限管理平台'
            },
            children: [
                {
                    path: '404',
                    name: '404',
                    meta: { name: '404页面' },
                    component: () => import('@/views/404/index.vue')
                },
                {
                    path: 'user/list',
                    name: 'userList',
                    meta: { name: '用户中心' },
                    component: () => import('@/views/user/index.vue')
                },
                {
                    path: 'corperates/list',
                    name: 'corperatesList',
                    meta: { name: '合作商管理' },
                    component: () => import('@/views/corperates/list.vue')
                },
                {
                    path: 'menus/list',
                    name: 'menusList',
                    meta: { name: '手册分类' },
                    component: () => import('@/views/menus/list.vue')
                },

                {
                    path: 'sale-nets/list',
                    name: 'saleNets',
                    meta: { name: '销售网络' },
                    component: () => import('@/views/sale-nets/list.vue')
                },
                {
                    path: 'global/config',
                    name: 'globalConfig',
                    meta: { name: 'globalConfig' },
                    component: () => import('@/views/global/config.vue')
                },
                {
                    path: 'global/pc',
                    name: 'globalPc',
                    meta: { name: 'globalPc' },
                    component: () => import('@/views/global/pc.vue')
                },
                {
                    path: 'quotes-config/list',
                    name: 'quotesConfig',
                    meta: { name: '选型手册' },
                    component: () => import('@/views/quotes-config/list.vue')
                },
                {
                    path: 'coupons/list',
                    name: 'couponsList',
                    meta: { name: '代金券优惠券' },
                    component: () => import('@/views/coupons/list.vue')
                }
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('@/views/login/index.vue')
        },
        {
            path: '/about-us',
            name: 'aboutUs',
            component: () => import('@/views/about-us/index.vue')
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: '/'
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else if (to.hash) {
            return {
                el: to.hash,
                top: 80,
                behavior: 'smooth'
            };
        } else {
            return { top: 80, behavior: 'smooth' };
        }
    }
});

export { router };
